import React, { Component } from 'react'
import { get } from "lodash"

import { checkIsValidFitnesLevel } from "./static.fitnesLevelData"
import { withStepsState } from "../../../shared/containers/containerStepsState"
import ButtonFill from "../../../shared/items/controls/buttonFill"

class FitnesLevelNextStepButton extends Component {
  componentDidUpdate() {
    const { data, onSetSuccessValidate } = this.props

    if (checkIsValidFitnesLevel(data))
      onSetSuccessValidate("fitnesLevel")
  }

  render() {
    const { data, onToNextStep } = this.props

    return (
      <ButtonFill disabled={!get(data, ["fitnesLevel", "isValid"], false)} onClick={onToNextStep}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(FitnesLevelNextStepButton)